import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { supabase } from "../supabase/client";
import { userErrorMessage } from "../utils/userErrorMessage";
import { useAuth } from "../components/AuthProvider";
import "../App.css";

export default function SubscriptionReturn() {
  const location = useLocation();
  const { user } = useAuth();
  const [result, setResult] = useState({ loading: location.pathname.endsWith("/success"), error: "" });
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const params = new URLSearchParams(location.search);
    window.history.replaceState({}, "", location.pathname);
    if (location.pathname.endsWith("/fail")) {
      setResult({ loading: false, error: "카드 등록이 취소되거나 실패했습니다. 다시 시도해 주세요." });
      return;
    }
    let checkout;
    try { checkout = JSON.parse(sessionStorage.getItem("busHubSignupCheckout") || "null"); }
    catch { checkout = null; }
    const authKey = params.get("authKey");
    const customerKey = params.get("customerKey");
    const plan = sessionStorage.getItem("busHubSubscriptionPlan");
    if (!authKey || !customerKey || !plan) {
      setResult({ loading: false, error: "결제 정보를 확인할 수 없습니다. 중복 결제하지 말고 고객센터에 문의해 주세요." });
      return;
    }
    supabase.functions.invoke("signup-subscription", {
      body: { action: "complete", ...(checkout || {}), authKey, customerKey, plan },
    }).then(async ({ data, error }) => {
      if (error || !data?.ok) {
        const response = await error?.context?.clone?.().json().catch(() => null);
        throw new Error(response?.error || "결제 결과를 확인하지 못했습니다. 중복 결제하지 말고 고객센터에 문의해 주세요.");
      }
      sessionStorage.removeItem("busHubSignupCheckout");
      sessionStorage.removeItem("busHubSubscriptionPlan");
      window.dispatchEvent(new Event("subscription-access-changed"));
      setResult({ loading: false, error: "" });
    }).catch((error) => setResult({ loading: false, error: userErrorMessage(error) }));
  }, [location.pathname, location.search]);

  return (
    <div className="login-background min-h-screen flex items-center justify-center p-4">
      <main className="w-full max-w-md rounded-md bg-white p-6 shadow-md">
        <h1 className="text-lg font-bold">BUS HUB 이용권 결제</h1>
        {result.loading ? <p role="status" className="mt-3">결제 결과를 확인하고 있습니다...</p>
          : result.error ? <p role="alert" className="mt-3 text-red-700">{result.error}</p>
            : <p role="status" className="mt-3">결제가 완료되었습니다. 회원 가입 승인 후 로그인할 수 있습니다.</p>}
        <div className="mt-5 flex gap-4 text-sm text-blue-700">
          {result.error && <Link to="/subscription">이용권 다시 확인</Link>}
          <Link to={user && !result.error ? "/reservations" : "/login"}>
            {user && !result.error ? "BUS HUB로 이동" : "로그인으로 돌아가기"}
          </Link>
        </div>
      </main>
    </div>
  );
}
